import { contracts, supportedNetwork } from './config'
import { useEffect, useLayoutEffect, useRef, useContext, useCallback } from 'react'
import { ethers } from 'ethers'
import { useAddress, useSigner } from "@thirdweb-dev/react";
import { ThirdwebSDK } from '@thirdweb-dev/sdk';
import { getRewardDurationFromUnixTime, getStakeDurationFromUnixTime } from '../utils';

const ERC20ABI = require('./abi/erc20.json')
const STAKINGABI = require('./abi/staking.json')


export const useStake = () => {
  const address = useAddress()
  const signer = useSigner();
  
  const claimCooldown = async _account => {
    if (_account === undefined) return 0
    const sdk = ThirdwebSDK.fromSigner(signer);
  
    const contract = await sdk.getContract(contracts.STAKING_ADDRESS, STAKINGABI)
    const cooldown = await contract.call(
          "TimeClaim",
          [
            _account
          ]
    )

    const formattedCooldown = getRewardDurationFromUnixTime(Math.floor(Date.now() / 1000) - cooldown)
    return formattedCooldown
  }

  const stakeCooldown = async _account => {
    if (_account === undefined) return 0
    const sdk = ThirdwebSDK.fromSigner(signer);
  
    const contract = await sdk.getContract(contracts.STAKING_ADDRESS, STAKINGABI)
    const cooldown = await contract.call(
          "TimeFactor",
          [
            _account
          ]
    )

    const formattedCooldown = getStakeDurationFromUnixTime(Math.floor(Date.now() / 1000) - cooldown)
    console.log(formattedCooldown)
    return formattedCooldown
  }

  const balanceOf = async _account => {
    if (_account === undefined) return 0
    const sdk = ThirdwebSDK.fromSigner(signer);
  
    const contract = await sdk.getContract(contracts.TOKEN_ADDRESS, ERC20ABI)
    const _balance = await contract.call(
          "balanceOf",
          [
            _account
          ]
      )

      return _balance
  }

  const approve = async () => {
    const sdk = ThirdwebSDK.fromSigner(signer);
    const uintMax =
      '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'

    const contract = await sdk.getContract(contracts.TOKEN_ADDRESS, ERC20ABI)
    const value = await contract.call(
      "allowance",
      [
        address,
        contracts.STAKING_ADDRESS
      ]
    )

    if (value.toString() === '0') {
      const tx = await contract.call(
        "approve",
        [
          contracts.STAKING_ADDRESS,
          uintMax
        ]
      )
    }
  }

  const isApprove = async () => {
    if (address === undefined) return 0
    const sdk = ThirdwebSDK.fromSigner(signer);
    
    const contract = await sdk.getContract(contracts.TOKEN_ADDRESS, ERC20ABI)
    const value = await contract.call(
      "allowance",
      [
        address,
        contracts.STAKING_ADDRESS
      ]
    )
    return value.toString() === '0'
  }

  const stake = async amount => {
    const sdk = ThirdwebSDK.fromSigner(signer);
    
    const contract = await sdk.getContract(contracts.STAKING_ADDRESS, STAKINGABI)
    const tx = await contract.call(
      "stake",
      [
        ethers.utils.parseUnits(amount.toString(), 9)
      ]
    )
  }

  const withdraw = async amount => {
    const sdk = ThirdwebSDK.fromSigner(signer);
    
    const contract = await sdk.getContract(contracts.STAKING_ADDRESS, STAKINGABI)
    const tx = await contract.call(
      'Unstake',
      [
        ethers.utils.parseUnits(amount.toString(), 9)
      ]
    )
  }

  const stakedAmount = async _account => {
    if (_account === undefined) return 0
    const sdk = ThirdwebSDK.fromSigner(signer);
    
    const contract = await sdk.getContract(contracts.STAKING_ADDRESS, STAKINGABI)
    const _balance = await contract.call(
      "TokensStaked",
      [
        _account
      ]
    )

    return _balance
  }

  const earned = async _account => {
    if (_account === undefined) return 0
    const sdk = ThirdwebSDK.fromSigner(signer);
    
    const contract = await sdk.getContract(contracts.STAKING_ADDRESS, STAKINGABI)
    const _balance = await contract.call(
      "CheckRewards",
      [
        _account
      ]
    )
    
    return _balance
  }

  const getReward = async () => {
    const sdk = ThirdwebSDK.fromSigner(signer);
    
    const contract = await sdk.getContract(contracts.STAKING_ADDRESS, STAKINGABI)
    const tx = await contract.call(
      "claimRewards"
    )

    console.log(tx)

  }

  const dailyReward = async _account => {
    if (_account === undefined) return 0
    const sdk = ThirdwebSDK.fromSigner(signer);
    
    const contract = await sdk.getContract(contracts.STAKING_ADDRESS, STAKINGABI)
    const _balance = await contract.call(
      "CalculateDailyReward",
      [
        _account
      ]
    )
    
    return _balance
  }

  return {
    approve,
    isApprove,
    stake,
    withdraw,
    balanceOf,
    stakedAmount,
    earned,
    getReward,
    dailyReward,
    claimCooldown,
    stakeCooldown 
  }
}

export const useInterval = (callback, delay) => {
  const savedCallback = useRef(callback)

  // Remember the latest callback if it changes.
  useLayoutEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (!delay && delay !== 0) {
      return
    }

    const id = setInterval(() => savedCallback.current(), delay)

    return () => clearInterval(id)
  }, [delay])
}
